import { ITemplatesStore } from '../index'

export default function(store: ITemplatesStore): ITemplatesStore {
  return {
    ...store,
    templateSendModal: {
      ...store.templateSendModal,
      isLoading: false,
      open: true,
    },
  }
}
